module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"detailsUrlLink":"Details","heatSourceTitle":"Wärmequelle","operatorTitle":"Betreiber","ghgFactorTitle":"Scope 1-2 EF","peFactorTitle":"Primärenergie (PEF)","statusTitle":"Status","distanceTitle":"Distanz","detailsUrlTitle":"Quelle"}}')
  delete Component.options._Ctor
}
